import React from 'react';
const TheadTableMarcas = () => {
  return (
    <thead className="sticky top-0 z-10 bg-gray-100 text-sm uppercase text-gray-700">
      <tr>
        <th
          scope="col"
          className="px-1 text-left uppercase">
          Id
        </th>
        <th
          scope="col"
          className="px-1 text-left uppercase">
          Marca
        </th>
        <th
          scope="col"
          className="px-1 text-left uppercase">
          Fecha Actualización
        </th>
        <th
          scope="col"
          className="px-1 text-left uppercase">
          Fecha Creación
        </th>
        <th
          scope="col"
          className="w-2"></th>
        <th
          scope="col"
          className="w-2"></th>
      </tr>
    </thead>
  );
};
export default TheadTableMarcas;
